/**
 * Builds `POST /conversations/{id}/messages` URL from the host-supplied
 * Sidekick API base URL (for example,
 * `${globalThis.appConfig.apiBaseUrl}/sidekick` in `mf-insights`) and
 * path-segment conversation id.
 */
export const buildMessagesUrl = (
  apiBaseUrl: string,
  conversationId: string
): string => {
  const base = apiBaseUrl.replace(/\/$/, '');
  return `${base}/conversations/${encodeURIComponent(conversationId)}/messages`;
};
